<form #resourcesForm="ngForm">
  <datalist id="scriptFiles">
    <option *ngFor="let scriptFileName of allScripts">{{scriptFileName}}</option>
  </datalist>
  <datalist id="styleFiles">
    <option *ngFor="let styleFileName of allStyles">{{styleFileName}}</option>
  </datalist>

  <!----------- style ----------->
  <h5>{{locale.LABEL_PREFAB_PROPS_STYLES}}</h5>
  <p>{{locale.MESSAGE_PREFAB_PROPS_STYLES}}</p>
  <table class="properties-table wm-table header-fixed">
    <thead>
    <tr>
      <th>{{locale.LABEL_PREFAB_CSS}}</th>
      <th width="8%"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let style of prefabConfig.resources.styles; let index = index;">
      <td><input class="col-xs-12 app-textbox form-control" [name]="'styles-' + index" [(ngModel)]="prefabConfig.resources.styles[index]" list="styleFiles" [ngModelOptions]="{updateOn: 'blur'}"></td>
      <td>
        <button type="button" class="btn app-button btn-transparent" (click)="removeStyle(index)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_STYLE}}">
          <i class="wm-icon wms wms-delete"></i>
        </button>
      </td>
    </tr>
    <tr>
      <td colspan="2"><input placeholder="{{locale.MESSAGE_PREFAB_PLACEHOLDER_STYLES}}" name="styles-input" class="col-xs-12 app-textbox form-control" (change)="addStyle()" [(ngModel)]="newProps.style" list="styleFiles" [ngModelOptions]="{updateOn: 'change'}"></td>
    </tr>
    </tbody>
  </table>

  <!----------- script ----------->
  <h5 class="category">{{locale.LABEL_PREFAB_PROPS_SCRIPTS}}</h5>
  <p>{{locale.MESSAGE_PREFAB_PROPS_SCRIPTS}}</p>
  <table class="properties-table wm-table header-fixed">
    <thead>
    <tr>
      <th>{{locale.LABEL_PREFAB_JAVASCRIPT}}</th>
      <th width="8%"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let script of prefabConfig.resources.scripts; let index = index;">
      <td><input class="col-xs-12 app-textbox form-control" [name]="'scripts-' + index" [(ngModel)]="prefabConfig.resources.scripts[index]" list="scriptFiles" [ngModelOptions]="{updateOn: 'blur'}"></td>
      <td>
        <button type="button" class="btn app-button btn-transparent" (click)="removeScript(index)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_SCRIPT}}">
          <i class="wm-icon wms wms-delete"></i>
        </button>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <input name="scripts-input" [(ngModel)]="newProps.script" placeholder="{{locale.MESSAGE_PREFAB_PLACEHOLDER_SCRIPTS}}" class="col-xs-12 app-textbox form-control" (change)="addScript()" list="scriptFiles" [ngModelOptions]="{updateOn: 'change'}">
      </td>
    </tr>
    </tbody>
  </table>
</form>
